<template>
    <div>
        <v-row v-if="GetPropertyInfo() !== null && GetPropertyInfo() !== undefined"
            class="mx-2 mt-2 d-flex justify-center">
            <v-col class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 custom-border">
                <h3 class="mb-1">General policy</h3>
                <div class="my-1">
                    <v-icon class="black--text darken-2" small>mdi-clock-outline</v-icon> Check-in:
                    <span class="font-weight-medium">{{ GetBookingPolicy().checkInFrom }}</span>
                    <!-- <span class="font-weight-black">To: {{GetBookingPolicy().checkInTo}}</span> -->
                </div>
                <div class="my-1">
                    <span>{{ GetBookingPolicy().checkInInstruction }}</span>
                </div>
                <div class="my-1">
                    <v-icon class="black--text darken-2" small>mdi-clock-outline</v-icon> Check-out:
                    <span class="font-weight-medium">{{ GetBookingPolicy().checkOutFrom }}</span>
                </div>
                <div class="my-1">
                    <span>{{ GetBookingPolicy().checkOutInstruction }}</span>
                </div>
                <div class="my-1 mt-3">
                    <h5>Children and extra beds</h5>
                </div>
                <div class="my-1">
                    <v-icon class="black--text darken-2" small>mdi-human-handsup</v-icon> Children
                    0-{{ GetBookingPolicy().maxChildAge }} old
                </div>
                <div class="my-1">
                    <span v-if="GetBookingPolicy().childAgeNotAllow === 0">All children are welcome</span>
                    <span v-if="GetBookingPolicy().childAgeNotAllow !== 0">Property does not accept children below age
                        {{ GetBookingPolicy().maxAllow }}</span>
                </div>
                <div class="my-1">
                    <span>Children under the age of {{ GetBookingPolicy().maxInfantAge }} are considered infants</span>
                </div>
                <div class="my-1">
                    <span>Property does not accept more than {{ GetBookingPolicy().maxAllow }} infant per room</span>
                </div>
                <div class="my-1">

                    <!-- <span v-html="GetBookingPolicy().bookingConditions"></span> -->
                    <v-dialog v-model="dialog" width="500">
                        <template v-slot:activator="{ on, attrs }">
                            <!-- <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
                                Click Me
                            </v-btn> -->
                            <a v-bind="attrs" v-on="on" class="text-decoration-none footer-link-hover">Others</a>
                        </template>

                        <v-card>
                            <v-card-title class="text-h5 grey lighten-2">
                                Others
                            </v-card-title>

                            <v-card-text>
                                <span v-html="GetBookingPolicy().cancellationPolicy"></span>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="dialog = false">
                                    Close
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </div>
                
            </v-col>

        </v-row>
        <v-row class="mx-2 mt-4 d-flex justify-center custom-border">
            <v-col class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                <h3 class="mb-1">Facilities</h3>
                <div>
                    <!-- <v-row v-if="facilities !== null && facilities.length !== 0">
                        <v-col v-for="(item,iitem) in facilities" cols="4" :key="iitem + 'facility-col'">
                            <feature-widget :Content="item.contentDescription" :Id="iitem" :Title="item.subCategory">
                            </feature-widget>

                        </v-col>
                    </v-row> -->
                    <v-row>
                        <v-col v-for="(item, iitem) in facilities" cols="4" :key="iitem + 'facility-col'">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <a href="#" :key="iitem + 'tooltip-href'"
                                            class="text-decoration-none footer-link-hover"> {{ item.subCategory }}</a>
                                    </span>
                                </template>
                                <span>{{ item.contentDescription }}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>

                </div>
            </v-col>
            <v-col class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                <h3 class="mb-1">Services & Others</h3>
                <div>
                    <!-- <v-row>
                        <v-col v-for="(item, iitem) in services" cols="4" :key="iitem + 'services-col'">
                            <feature-widget :Content="item.contentDescription" :Id="iitem" :Title="item.subCategory">
                            </feature-widget>
                        </v-col>
                    </v-row> -->
                    <v-row>
                        <v-col v-for="(item, iitem) in services" cols="4" :key="iitem + 'services-col'">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <a href="#" :key="iitem + 'tooltip-href'"
                                            class="text-decoration-none footer-link-hover"> {{ item.subCategory }}</a>
                                    </span>
                                </template>
                                <span>{{ item.contentDescription }}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
    </div>
</template>


<script>
import { mapGetters } from "vuex";

import FeatureWidget from "./FeatureWidget.vue";

export default {
    data() {
        return {
            icons: [
                'mdi-facebook',
                'mdi-youtube',
                'mdi-instagram',
            ],
            dialogCancellation: false,
            dialog: false
        }
    },
    components: {
        FeatureWidget
    },
    computed: {
        ...mapGetters([
            'GetBookingPolicy',
            'GetPropertyInfo',
            'GetPropertyFacilitiesAndServices']),
        facilities: function () {

            if (!this.GetPropertyFacilitiesAndServices())
                return [];

            return this.GetPropertyFacilitiesAndServices().filter(f => f.categoryId == 'Feature')
        },
        services: function () {
            if (!this.GetPropertyFacilitiesAndServices())
                return [];

            return this.GetPropertyFacilitiesAndServices().filter(f => f.categoryId == 'Services')
        }
    },
}
</script>


<style>
.custom-border {
    padding: 16px;
    border-radius: 4px;
    border: 1px solid rgb(221, 223, 226);
}
</style>